// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"3e55e839","787":"c3b18a7b"}[chunkId] + ".chunk.js";
};